import React from 'react';
import SubscriptionCard from '../../components/SubscriptionCard';

export default function Subscription() {
  return <SubscriptionCard />;
}
